import _ from 'lodash';
import getPassengerFlightSeats from './getPassengerFlightSeats';

const computeTotalSeatCost = (travelers, flightItinerary = null) => {
  const seats = getPassengerFlightSeats(travelers, flightItinerary);
  return _.sumBy(seats, 'price') || 0;
};

export default computeTotalSeatCost;
